import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getTenantConsents } from '../services/consents';

export default function MyConsents() {
  const navigate = useNavigate();
  const [error, setError] = useState(false);

  useEffect(() => {
    getTenantConsents()
      .then((res) => {
        const items = res.data.data?.items || [];
        if (items.length === 0) {
          setError(true);
          return;
        }
        const selectedTenantId = localStorage.getItem('tenant_id');
        const company =
          items.find((item) => (item.tenant_id || item.id) === selectedTenantId) ||
          items[0];
        const id = company.tenant_id || company.id;
        const name = company.tenant_name || company.name;
        localStorage.setItem('tenant_id', id);
        if (name) localStorage.setItem('tenant_name', name);
        navigate(`/consents/${id}`, { state: { companyName: name }, replace: true });
      })
      .catch(() => setError(true));
  }, [navigate]);

  if (error) {
    return (
      <div className="p-6 text-center text-gray-400 text-sm">No companies found.</div>
    );
  }

  return (
    <div className="p-6 text-center text-gray-400 text-sm">Loading...</div>
  );
}
